import { Component, inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UpdateService } from '../../services/update/update.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-splash',
  imports: [AsyncPipe],
  templateUrl: './splash.html',
  styleUrl: './splash.scss',
})
export class Splash implements OnInit {
  updateService = inject(UpdateService);
  progress$: Observable<number>;
  hasUpdate = this.updateService.hasUpdate;

  constructor() {
    this.progress$ = this.updateService.progress$;
  }

  ngOnInit(): void {
    //this.updateService.checkUpdateAndStart();
  }

  startUpdate() {
    //this.updateService.startUpdate();
  }
}
